import { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  category: {
    fontWeight: "bold",
    opacity: "1 !important",
  },
  selectFlex: {
    "& .MuiSelect-select": {
      display: "flex",
    },
  },
}));

export default function ArmyPicker({
  label,
  name,
  value,
  handleChange,
  armies,
  touched,
  error,
  clearable,
  clearLabel,
  ...rest
}) {
  const classes = useStyles();
  const [items, setItems] = useState([]);
  useEffect(() => {
    const check = async () => {
      var itemArray = [];
      if (armies?.length) {
        armies.forEach((army) => {
          if (army.childArmies?.length > 0) {
            itemArray.push(
              <MenuItem disabled value="" className={classes.category}>
                {army.name}
              </MenuItem>
            );
            army.childArmies.forEach((childArmy) => {
              itemArray.push(
                <MenuItem key={childArmy.id} value={childArmy.id}>
                  {childArmy.name}
                </MenuItem>
              );
            });
          } else {
            itemArray.push(
              <MenuItem key={army.id} value={army.id}>
                {army.name}
              </MenuItem>
            );
          }
        });
      }
      setItems(itemArray);
    };
    check();
    // eslint-disable-next-line
  }, [armies]);

  if (!armies) {
    return (
      <TextField
        label={label || "Faction"}
        value="...loading"
        variant="outlined"
        fullWidth
        disabled
        {...rest}
      />
    );
  }

  return (
    <FormControl
      fullWidth
      variant="outlined"
      className={classes.formControl}
      {...rest}
    >
      <InputLabel id={`${name}-label`}>{label || "Faction"}</InputLabel>
      <Select
        error={Boolean(touched && error)}
        fullWidth
        helperText={touched && error}
        labelId={`${name}-label`}
        name={name}
        value={value}
        onChange={handleChange}
        label={label || "Faction"}
        variant="outlined"
        {...rest}
      >
        {clearable && (
          <MenuItem value="">
            <em>{clearLabel || "Clear"}</em>
          </MenuItem>
        )}
        {items &&
          items.map((army) => {
            return army;
          })}
      </Select>
    </FormControl>
  );
}
